import { Card, Col } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import {
  ProjectOverviewHighlightTileDates,
  ProjectOverviewHighlightTileStatus,
  ProjectOverviewHighlightTileProgress,
} from './cards';

const HighlightTile = styled(Card).attrs({
  bordered: false,
})`
  height: 96px;
  max-height: 96px;
`;

export const HighlightSection: FC<{ projectId: number }> = ({ projectId }) => {
  return (
    <>
      <Col xl={8} xs={24}>
        <HighlightTile>
          <ProjectOverviewHighlightTileStatus projectId={projectId} />
        </HighlightTile>
      </Col>
      <Col xl={8} xs={24}>
        <HighlightTile>
          <ProjectOverviewHighlightTileDates projectId={projectId} />
        </HighlightTile>
      </Col>
      <Col xl={8} xs={24}>
        <HighlightTile>
          <ProjectOverviewHighlightTileProgress projectId={projectId} />
        </HighlightTile>
      </Col>
    </>
  );
};
